import { createStore } from 'zustand';

export type FlexibleRange = 'exact' | '1 day' | '3 days' | '7 days';
export type DateOrRange = string | [string, string] | undefined;

interface DepartureDateState {
  departureDate: DateOrRange;
  flexibleRange: FlexibleRange;
  originDate: string | undefined;
  view: 'calendar' | 'month';
}

export type DepartureDateStore = DepartureDateState & DepartureDateActions;
interface DepartureDateActions {
  setDepartureDate: (departureDate: DateOrRange) => void;
  setFlexibleRange: (flexibleRange: FlexibleRange) => void;
  setOriginDate: (originDate: string | undefined) => void;
  setView: (view: 'calendar' | 'month') => void;
  reset: () => void;
}
const initialState: DepartureDateState = {
  departureDate: undefined,
  flexibleRange: 'exact',
  originDate: '',
  view: 'calendar',
};

export const createDepartureDateStore = (initState: DepartureDateState) =>
  createStore<DepartureDateStore>((set) => ({
    ...initState,
    setDepartureDate: (departureDate) => {
      set(() => ({ departureDate }));
    },
    setFlexibleRange: (flexibleRange) => {
      set(() => ({ flexibleRange }));
    },
    setOriginDate: (originDate) => {
      set(() => ({ originDate }));
    },
    setView: (view) => {
      set(() => ({ view }));
    },
    reset: () => {
      set(() => ({ departureDate: undefined, originDate: undefined }));
    },
  }));

export const departureDateStore = createDepartureDateStore(initialState);
